var validate = require("validate.js");

export default class Point {

	constructor(params) {
      	this.name = params.name;
        this.name_ar = params.name_ar;
        this.description = params.description;
        this.description_ar = params.description_ar;
        // this.step = params.step;
        this.category = params.category;
        this.categoryLabel = params.label;
        this.visible = params.visible;
        this.searchable = params.searchable;
        this.clickable = params.clickable;
  	}


  	toString() {
        return this.name;
    }

    getName(){
    	  return this.name;
    }


    validate(){
        var constraints = {
          category: {
            presence: {
              allowEmpty: false
            }
          },
          name: {
            presence: true,
            length: {
              minimum: 2,
              message: "must be at least 2 characters"
            }
          },
          name_ar: {
            presence: true,
            length: {
              minimum: 2,
              message: "must be at least 2 characters"
            }
          }
          // description: {
          //   presence: true,
          //   length: {
          //     minimum: 5,
          //     maximum:120,
          //     message: "must be at minimum 5 and maximum 120 characters"
          //   }
          // },
          // description_ar: {
          //   presence: true,
          //   length: {
          //     minimum: 5,
          //     maximum:120,
          //     message: "must be at minimum 5 and maximum 120 characters"
          //   }
          // }
        };
        return validate({category: this.category,name:this.name,name_ar:this.name_ar}, constraints);
    }

    isLift(){
        if(!this.categoryLabel) return false;
        return this.categoryLabel.toLowerCase() == "lift" ? true : false;
    }

    


}